export enum INPUT_FIELD {
  Email = "email",
  Password = "password"
}

export enum PASSWORD_TYPE {
  Current = "current",
  Repeat = "repeat",
  NewPsw = "newPsw"
}

export enum BUTTON_TYPE {
  SignUp = "sign up",
  ResetPsw = "reset password",
  NewPsw = "newPsw",
  ChangePsw = "change password"
}

export enum AUTH_ERRORS {
  InvitationExpired = "Invitation expired"
}

export enum ENABLE_AUTHENTICATION_STEPS {
  GetSecretKey,
  SendOtpCode,
  SuccessMessage,
  SelectMethod,
  GetEmailCode,
  SendEmailCode
}

export enum DISABLE_AUTHENTICATION_STEPS {
  Confirmation,
  SendPassword
}

export enum AUTHENTICATION_TYPES {
  Authenticator = "Authenticator",
  Email = "Email",
  None = "None"
}
